"use client"

import { useEffect } from "react"

export function ResizeObserverErrorHandler() {
  useEffect(() => {
    const handler = (e: ErrorEvent) => {
      if (
        e.message === "ResizeObserver loop completed with undelivered notifications." ||
        e.message === "ResizeObserver loop limit exceeded"
      ) {
        e.stopImmediatePropagation()
        e.preventDefault()
      }
    }
    
    window.addEventListener("error", handler)
    return () => window.removeEventListener("error", handler)
  }, [])

  return null
}
